import { Dialog } from '@base-ui/react/dialog';
import { IconX } from '@tabler/icons-react';
import type { ReactNode } from 'react';

export function StudioDialog({
  open,
  onOpenChange,
  title,
  description,
  children,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  children: ReactNode;
}) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Backdrop className="studio-dialog-backdrop" />
        <Dialog.Popup className="studio-dialog">
          <div className="studio-dialog-heading">
            <div>
              <Dialog.Title>{title}</Dialog.Title>
              <Dialog.Description>{description}</Dialog.Description>
            </div>
            <Dialog.Close className="studio-icon-button" aria-label="Close dialog">
              <IconX />
            </Dialog.Close>
          </div>
          {children}
        </Dialog.Popup>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
